var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-main"},[_c('SLeftSideComponent'),_c('div',{staticClass:"auth-right"},[_c('div',{staticClass:"right-main d-flex flex-column h-100"},[_c('SRightHeaderComponent'),_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }